import { Component, HostListener, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IServiceLink } from '../../../../interfaces/IServiceLink';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SharedModule } from 'primeng/api';
import { RouterLinkWithHref } from '@angular/router';
// import { MetrikaGoalDirective } from 'ng-yandex-metrika';
// import { InlineSVGModule } from '@rentaggregator/inline-svg';
import { LabelNewComponent } from './components/label-new/label-new.component';
import {ClientSideRenderingDirective} from '../../../../../../common/directives/client-side-rendering.directive';

@Component({
  selector: 'ra-header-service-menu',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    OverlayPanelModule,
    SharedModule,
    RouterLinkWithHref,
    ClientSideRenderingDirective,
    LabelNewComponent
  ],
  templateUrl: './service-menu.component.html',
  styleUrls: ['./service-menu.component.scss'],
})
export class HeaderServiceMenuComponent {
  @Input() label!: string;
  @Input() links!: IServiceLink[];

  menuState = false;

  @HostListener('mouseenter') onMouseEnter() {
    this.menuState = true;
  }
  @HostListener('mouseleave') onMouseLeave() {
    this.menuState = false;
  }

  generateLink(link: string, queryParams?: { [key: string]: any }): string {
    if (!queryParams || Object.keys(queryParams).length === 0) {
      return `https://rentag.ru${link}`;
    }
    const queryString = Object.keys(queryParams)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`
      )
      .join('&');
    return `https://rentag.ru${link}?${queryString}`;
  }
}
